import { render, staticRenderFns } from "./ActivityRecord.vue?vue&type=template&id=a3c57bfc&"
import script from "./ActivityRecord.vue?vue&type=script&lang=js&"
export * from "./ActivityRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports